import { createFeatureSelector, createSelector } from '@ngrx/store';
import { userFeatureKey, UserState } from '../reducers/user.reducer';

export const selectUserState = createFeatureSelector<UserState>(userFeatureKey);

export const selectCurrentUser = createSelector(selectUserState, (state) => state.currentUser);

export const selectUserLoading = createSelector(selectUserState, (state) => state.loading);

export const selectUserError = createSelector(selectUserState, (state) => state.error);
